/**
 * ContactPage - Generated page component.
 */
import React, { useEffect } from 'react';
import HeroCard from '../components/cards/HeroCard';
import ContactFormCard from '../components/cards/ContactFormCard';
import FeatureCard from '../components/cards/FeatureCard';
import StatisticCard from '../components/cards/StatisticCard';

const ContactPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Contact | Thornless Data Management';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', "Tell us about your data challenge. We'll set up a Discovery call to understand your business needs and walk you through what's possible.");
  }, []);

  return (
    <main>

      <section className="layout-full" aria-label="ContactHero">
            <HeroCard eyebrow={"Let's Talk"} headline={"Tell Us About Your Data Challenge"} subheadline={"We'll set up a Discovery call to explore what's possible: no pressure, no sales pitch."} variant={"Focused"}/>
      </section>
      <section className="layout-container section-padding" aria-label="ContactMain">
            <ContactFormCard title={"Get in Touch"} subtitle={"Tell us about your data challenges."} successMessage={"Thanks for reaching out. We'll be in touch within one business day."} fields={[{"name": "name", "label": "Full Name", "type": "text", "required": true}, {"name": "email", "label": "Email Address", "type": "email", "required": true}, {"name": "company", "label": "Company", "type": "text", "required": false}, {"name": "service", "label": "Area of Interest", "type": "select", "options": ["Data Management Pipelines", "Analytics & Business Intelligence", "Agentic AI Automation", "Data Warehousing", "Not Sure - I Need Guidance"], "required": false}, {"name": "message", "label": "Tell us about your data challenge", "type": "textarea", "required": true}]}/>
            <FeatureCard title={"Why Thornless"} body={"We work across a broad, modern technology stack, from cloud data warehouses to agentic AI, and we recommend what fits your needs, not what's easiest for us."} bullets={["Platform-Agnostic: AWS, Azure, GCP, Snowflake, Databricks, and more", "Stress-Free Process: We handle the complexity so you stay focused", "Insight-Focused: Every solution is built to surface decisions, not just store data", "Security-First: Compliance and data governance built in from day one", "Honest Guidance: We'll tell you what you actually need, even if it's less"]}/>
      </section>
      <section className="layout-container section-padding" aria-label="ContactStats">
            <StatisticCard value={"1 Business Day"} label={"Response Time"}/>
            <StatisticCard value={"Free"} label={"Discovery Call"}/>
            <StatisticCard value={"0"} label={"Long-Term Contracts Required"}/>
      </section>
    </main>
  );
};

export default ContactPage;
